$(document).ready(function () {
  const chaosInstances = new Map();
  const $containers = $('.collection-grid');
  const $products = $('.product');

  function positionProducts() {
    $('body').removeClass('absolute-products');
  
    $products.each(function () {
      const $product = $(this);
  
      if (!chaosInstances.has(this)) {
        const offset = $product.offset();
        const width = $product.outerWidth();
        const height = $product.outerHeight();
  
        $product.css({
          left: offset.left + 'px',
          top: offset.top + 'px'
        });
  
        console.log(offset.left, offset.top);
        $product.attr('data-left', offset.left).attr('data-top', offset.top);
      }
    });

    $containers.each(function () {
      const $container = $(this);
      const height = $container.outerHeight();
  
      $container.css({
        height: height + 'px'
      });
    });
  
    $('body').addClass('absolute-products');
  }

  $(window).resize(function () { 
    if(!$('body').is('chaos')) {
      console.log('Resize');
      positionProducts();
    }
  });

  positionProducts();

  $('button[data-mode="chaos"]').on('click', function () {
    $('button[data-mode="order"]').removeClass('active');
    $(this).addClass('active');
    $('body').addClass('chaos');
    
    $products.each(function () {
      if (!chaosInstances.has(this)) {
        startChaos(this);
      }
    });
  });

  $('button[data-mode="order"]').on('click', function () {
    $('button[data-mode="chaos"]').removeClass('active');
    $(this).addClass('active');
    $('body').removeClass('chaos');

    chaosInstances.forEach((instance, element) => {
      cancelAnimationFrame(instance.rafId);

      const $el = $(element);
      const left = $el.attr('data-left');
      const top = $el.attr('data-top');

      $el.css({
        left: left + 'px',
        top: top + 'px',
      });
    });

    chaosInstances.clear();
  });

  function startChaos(element) {
    const speed = 0.3 + Math.random() * 0.7;
    let angle = Math.random() * 2 * Math.PI;

    let x = parseFloat($(element).attr('data-left'));
    let y = parseFloat($(element).attr('data-top'));

    const width = $(element).outerWidth();
    const height = $(element).outerHeight();

    function move() {
      const maxX = $(document).width() - width;
      const maxY = $(document).height() - height;

      angle += (Math.random() - 0.5) * 0.2;
      x += Math.cos(angle) * speed;
      y += Math.sin(angle) * speed;

      if (x < 0) {
        x = 0;
        angle = Math.PI - angle;
      } else if (x > maxX) {
        x = maxX;
        angle = Math.PI - angle;
      }

      if (y < 0) {
        y = 0;
        angle = -angle;
      } else if (y > maxY) {
        y = maxY;
        angle = -angle;
      }

      $(element).css({
        left: x + 'px',
        top: y + 'px',
      });

      const rafId = requestAnimationFrame(move);
      chaosInstances.set(element, { rafId });
    }

    const rafId = requestAnimationFrame(move);
    chaosInstances.set(element, { rafId });
  }

  $('.year-separator').click(function () { 
    $('.collection-grid').not($(this).prev()).removeClass('active');
    $('.year-separator').not($(this)).removeClass('active');
    $(this).prev().addClass('active');
    $(this).addClass('active');
  });

});
